import { render } from "./Otec.vue?vue&type=template&id=4d9b336e&ts=true"
import script from "./Otec.vue?vue&type=script&lang=ts"
export * from "./Otec.vue?vue&type=script&lang=ts"

import "./Otec.vue?vue&type=style&index=0&id=4d9b336e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__